<div class="product-la-carte">
    <div class="product-la-carte__img">
        <a [routerLink]="['/shop/'+(product()?.productUrl || '')]">
            <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" class="thumb-img"
                (error)="handleImageError($event)">
        </a>
    </div>
    <div class="product-la-carte__left">
        <a class="card-title" [routerLink]="['/shop/'+(product()?.productUrl || '')]">
            {{ product()?.name }}
        </a>
        @if (product()?.variant?.attribute?.name) {
        <p class="card-text pt-0 mb-0">
            {{ product()?.variant?.attribute?.name }}: {{ product()?.variant?.attribute?.value?.name }}
        </p>
        }
        @if (product()?.package) {
        <p class="card-text pt-0 mb-0">
            Package: {{ product()?.package?.name }}
        </p>
        }
        @if (product()?.subscription) {
        {{ ((product()?.package?.name || product()?.variant?.attribute?.name) ? ' | ' : '') + 'Frequency: ' +
        product()?.subscription?.frequency?.name }}
        }
        <div class="row-field animated fadeIn">
            @if (isValueHigherThan10()) {
            <label class="row-field__label">How many?</label>
            }
            <div class="row-field__input">
                <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
                    @if (isValueHigherThan10()) {
                    <input type="text" matInput appNumberRestriction [minNumber]="1" [maxNumber]="100"
                        [value]="newQuantity()" (input)="onInputQuantityChange($event)" [readonly]="product().isPreOrder">
                    } @else {
                    <mat-select [value]="newQuantity()" (selectionChange)="onQuantityChange($event)"
                        panelClass="quantity-select-panel" disableOptionCentering>
                        @for(q of availableQuantities(); track $index){
                        <mat-option [value]="q.val">{{ q.name }}</mat-option>
                        }
                    </mat-select>
                    }
                </mat-form-field>
            </div>
            <div class="row-field__action">
                @if (showUpdateButton()) {
                <button type="button" class="btn btn-primary" (click)="validateQuantity()">
                    Update
                </button>
                }
            </div>

            @if(!isMobile()) {
            @if (product()?.bundle && product()?.bundle?.items?.length) {

            <div class="border-start btn-delete__wrap">
                @let isBundleLocked = product().bundle.isLocked && !product().bundle.hasPremiumAddables;
                @let bundleText = isBundleLocked ? "What's Inside" : "Edit Bundle";
                <small class="text-decoration-underline cursor-pointer" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#'+toggleId()" [attr.aria-controls]="toggleId()">
                    <span class="link-underline">{{ bundleText }}</span>
                </small>
            </div>
            }

            @if (isSubscription()) {
            <div class="col border-start btn-delete__wrap">
                <small class="text-decoration-underline cursor-pointer" (click)="skipProduct()">Skip</small>
            </div>
            } @else if (!product().isPreOrder) {
            <div class="col border-start btn-delete__wrap">
                <small class="text-decoration-underline cursor-pointer" (click)="deleteProduct()">
                    {{isDeletingProduct() ? 'Deleting...' : 'Delete'}}
                </small>
            </div>
            }
            }

        </div>
    </div>
    <div class="product-la-carte__right">

        @if(!product()?.bundle?.items?.length && product().bundle?.priceRange) {
        <h3 class="price-range">{{product().bundle.priceRange}}</h3>
        } @else {
        <div class="d-flex gap-1 justify-content-center align-items-center flex-wrap">
            <h3 class="price">{{totalPrice() | currency}}</h3>
            @if (product().originalTotalPrice && product().originalTotalPrice !== totalPrice()) {
            <h3 class="original-price">{{product().originalTotalPrice | currency}}</h3>
            }
        </div>
        }

        @if (product().isConfirmed) {
        <span class="badge bg-success">In your order</span>
        } @else {
        <span class="badge bg-warning">Not yet saved</span>
        }
    </div>
</div>


@if(isMobile()) {
<div class="w-100 d-flex justify-content-between">
    @if (isSubscription()) {
    <button class="btn btn-outline-secondary btn-product-action-mobile" (click)="skipProduct()">
        Skip
    </button>
    } @else if(!product().isPreOrder) {
    <button class="btn btn-outline-secondary btn-product-action-mobile" (click)="deleteProduct()"
        [class.disabled-action]="isDeletingProduct() && !product().isDeleting"
        [disabled]="isDeletingProduct() && !product().isDeleting">
        {{product().isDeleting ? 'Deleting...': 'Delete'}}
    </button>
    }
    @if (product()?.bundle && product()?.bundle?.items?.length) {

    <div class="btn-delete__wrap">
        <small class="text-decoration-underline cursor-pointer">
            @let isBundleLocked = product().bundle.isLocked && !product().bundle.hasPremiumAddables;
            @let bundleText = isBundleLocked ? "What's Inside" : "Edit Bundle";
            <button class="btn btn-outline-secondary btn-product-action-mobile" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#'+toggleId()" aria-expanded="false"
                [attr.aria-controls]="toggleId()">{{bundleText}}</button>

        </small>
    </div>
    }
</div>
}

@if (product().isPreOrder) {
<app-empty-message [message]="preOrderedProductDisclaimer"></app-empty-message>
}

@if (product()?.bundle && product()?.bundle?.items?.length) {
<div class="row animated fadeIn collapse" [attr.id]="toggleId()"
    [attr.data-bs-parent]="accordionParentId ? ('#' + accordionParentId) : null">
    <app-bundle-edition [product]="product()" [toggleId]="toggleId()"
        (outUpdateProduct)="updateProduct($event.product)"></app-bundle-edition>
</div>
}

<hr>